import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { URadioButtonComponent } from './u-radio-button.component';
import { MatRadioModule } from '@angular/material/radio';
import { MAT_RIPPLE_GLOBAL_OPTIONS, RippleGlobalOptions } from '@angular/material/core';
const globalRippleConfig: RippleGlobalOptions = {
  disabled: true,
};
@NgModule({
  declarations: [URadioButtonComponent],
  imports: [CommonModule, MatRadioModule, FormsModule, CommonModule, ReactiveFormsModule],
  exports: [URadioButtonComponent],
  providers: [{ provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig }],
})
export class URadioButtonModule {}
